import bindScroll from 'helpers/bindScroll';
import brandLandscapeCarousel from 'components/brandLandscapeCarousel';

export default function brandCarousel(brandCarousel, objs) {
    try {
        objs.push({
            wrapper: brandCarousel,
            init: function () {
                brandCarousel.on('init', () => {
                    brandCarousel.removeClass('hidden');
                });

                brandCarousel.on('setPosition', () => {
                    brandCarousel.ellipsify();
                });

                let params = {
                    parentContainer: brandCarousel,
                    options: {
                        endPoint:
                            CBS.Registry.region.prefix +
                            '/carousels/homepage/brands/offset/0/limit/30/',
                        fetchData: true
                    }
                };

                brandLandscapeCarousel(params);
            }
        });
    } catch (e) {}
}
